import React from "react"

const CardWrapper = ({ children, minW = "130" }) => {
  return (
    <div className={`w-full min-w-[130px]`}>
      <div className="relative bg-white rounded-md shadow-md px-3 py-1">{children}</div>
    </div>
  )
}

export default CardWrapper
